import router from '@/router';
import { elealert } from '@/utils/ele';
import storage from '@/utils/storage';
import settings from '@/utils/settings'; //引入基础配置

router.beforeEach((to, from, next) => {
	const access_token = storage.get(settings.storagePrefix + 'access_token');

	if (access_token == '') {
		if (settings.whiteUrl.indexOf(to.path) !== -1) {
			//在路由白名单内
			next();
		} else {
			//否则跳转至登录页
			next({ path: '/login' });
		}
	} else {
		const usermenulist = storage.get(settings.storagePrefix + 'usermenulist');
		if (to.path === '/login') {
			//已经存在access_token时，若打开登录页则跳转至首页
			to.path = usermenulist.list[0]['path'];
			next({ path: to.path });
		} else {
			//验证菜单权限
			if (typeof (usermenulist.list) == "undefined") {
				storage.clear();
				next({ path: '/login' });
			}
			if (to.path === '/') {
				to.path = usermenulist.list[0]['path'];
				next({ path: to.path });
			} else {
				if (usermenulist.auth.includes(to.path)) {
					next();
				} else {
					elealert({
						title: '提示',
						message: '您没有权限！',
						type: 'error',
						confirmButtonText: '确定'
					}).then(() => {
						next({ path: usermenulist.list[0]['path'] });
					}).catch(() => {
						next({ path: usermenulist.list[0]['path'] });
					});
				}
			}
		}
	}
});